export const chips = () => ({
    display: 'flex',
});
